// /src/components/LanguagePicker.js
import React from "react";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ReactCountryFlag from "react-country-flag";

const useStyles = makeStyles({
  select: {
    fontSize: "0.875rem", // Lower text size (14px)
  },
  menuItem: {
    fontSize: "0.875rem", // Lower text size in menu items
  },
  flagIcon: {
    fontSize: "1.25em",
    marginRight: "8px",
  },
});

const LOCAL_STORAGE_KEY_LANG = "lang";

const LanguagePicker = ({ sx }) => {
  const { i18n } = useTranslation();
  const classes = useStyles();

  const handleChange = (event) => {
    i18n.changeLanguage(event.target.value);
    localStorage.setItem(LOCAL_STORAGE_KEY_LANG, event.target.value);
  };

  return (
    <Select
      value={i18n.language}
      onChange={handleChange}
      variant="outlined"
      color="secondary"
      size="small"
      classes={{ root: classes.select }}
      sx={sx}
    >
      <MenuItem value="en" className={classes.menuItem}>
        <Box display="flex" alignItems="center">
          <ReactCountryFlag countryCode="GB" svg className={classes.flagIcon} />
          EN
        </Box>
      </MenuItem>
      <MenuItem value="hu" className={classes.menuItem}>
        <Box display="flex" alignItems="center">
          <ReactCountryFlag countryCode="HU" svg className={classes.flagIcon} />
          HU
        </Box>
      </MenuItem>
    </Select>
  );
};

export default LanguagePicker;
